<template>
  <Menu mode="horizontal" :active-name="current">
    <div class="layout-nav">
      <MenuItem name="1" to="/">
        <Icon type="md-search" />
        Log查詢
      </MenuItem>
      <MenuItem name="2" to="/deploy">
        <Icon type="md-search" />
        Deployment狀態
      </MenuItem>
    </div>
  </Menu>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      current: "1",
    }
  },
  mounted() {
    this.current = this.$route.path == "/deploy" ? "2" : "1"
  },
}
</script>

<style scoped>
.layout-nav {
  margin: 0 15%;
}

@media screen and (max-width: 768px) {
  .layout-nav {
    margin: 0 5%;
  }
}
</style>
